<script>
  import { FolderOpenDot, MessageSquareText, Sparkles } from 'lucide-svelte';

  export let variant = 'center';
  export let title = 'Chọn một cuộc trò chuyện';
  export let description = 'Tin nhắn, tài liệu và nội dung được chia sẻ sẽ xuất hiện ở đây ngay khi bạn mở một cuộc trò chuyện.';

  $: isSidebar = variant === 'sidebar';
</script>

<section class:sidebar={isSidebar} class="empty-shell">
  <div class="hero-orb"></div>
  <div class="hero-card">
    <div class="icon-stack">
      <span class="icon major"><MessageSquareText size={isSidebar ? 24 : 30} /></span>
      <span class="icon minor top"><Sparkles size={isSidebar ? 14 : 16} /></span>
      <span class="icon minor bottom"><FolderOpenDot size={isSidebar ? 14 : 16} /></span>
    </div>

    <div class="copy">
      <h3>{title}</h3>
      <p>{description}</p>
    </div>

    {#if !isSidebar}
      <div class="tips">
        <div>Gọi thoại, gọi video và chia sẻ màn hình sẽ sẵn sàng khi bạn mở đoạn chat.</div>
        <div>Ảnh, video, file và liên kết được gom lại ở khung thông tin bên phải.</div>
      </div>
    {/if}
  </div>
</section>

<style>
  .empty-shell {
    position: relative;
    display: grid;
    place-items: center;
    width: 100%;
    height: 100%;
    min-height: 0;
    padding: 1.5rem;
    overflow: hidden;
    background:
      radial-gradient(circle at top left, rgba(14, 165, 233, 0.12), transparent 18rem),
      radial-gradient(circle at bottom right, rgba(249, 115, 22, 0.12), transparent 22rem),
      linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(248, 250, 252, 0.96));
  }

  .empty-shell.sidebar {
    padding: 1.2rem;
    background:
      radial-gradient(circle at top center, rgba(14, 165, 233, 0.09), transparent 14rem),
      linear-gradient(180deg, #ffffff, #f8fafc);
  }

  .hero-orb {
    position: absolute;
    width: 22rem;
    height: 22rem;
    border-radius: 999px;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.9), rgba(186, 230, 253, 0.08) 55%, transparent 72%);
    filter: blur(14px);
    pointer-events: none;
  }

  .hero-card {
    position: relative;
    z-index: 1;
    width: min(34rem, 100%);
    padding: 1.6rem;
    border: 1px solid rgba(148, 163, 184, 0.16);
    border-radius: 1.75rem;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 28px 60px rgba(15, 23, 42, 0.08);
    backdrop-filter: blur(18px);
  }

  .sidebar .hero-card {
    width: 100%;
    padding: 1.25rem;
    border-radius: 1.35rem;
    box-shadow: 0 18px 40px rgba(15, 23, 42, 0.06);
  }

  .icon-stack {
    position: relative;
    width: fit-content;
    margin: 0 auto 1rem;
  }

  .icon {
    display: grid;
    place-items: center;
    border-radius: 1.2rem;
    color: #0f172a;
    background: white;
    box-shadow: 0 14px 32px rgba(15, 23, 42, 0.12);
  }

  .icon.major {
    width: 4rem;
    height: 4rem;
    color: #0f766e;
    background: linear-gradient(145deg, #ccfbf1, #f0fdfa);
  }

  .sidebar .icon.major {
    width: 3.2rem;
    height: 3.2rem;
  }

  .icon.minor {
    position: absolute;
    width: 1.8rem;
    height: 1.8rem;
  }

  .icon.minor.top {
    top: -0.45rem;
    right: -0.9rem;
    color: #ea580c;
  }

  .icon.minor.bottom {
    right: -1.15rem;
    bottom: -0.35rem;
    color: #0284c7;
  }

  .copy {
    text-align: center;
  }

  .copy h3 {
    font-size: 1.05rem;
    font-weight: 700;
    color: #0f172a;
  }

  .copy p {
    margin-top: 0.45rem;
    color: #64748b;
    font-size: 0.82rem;
    line-height: 1.55;
  }

  .tips {
    display: grid;
    gap: 0.7rem;
    margin-top: 1.15rem;
  }

  .tips div {
    padding: 0.85rem 0.95rem;
    border-radius: 1rem;
    color: #334155;
    background: linear-gradient(180deg, rgba(248, 250, 252, 0.9), rgba(241, 245, 249, 0.95));
    font-size: 0.77rem;
    line-height: 1.5;
  }

  @media (max-width: 720px) {
    .empty-shell {
      padding: 1rem;
    }

    .hero-card {
      padding: 1.25rem;
      border-radius: 1.35rem;
    }
  }
</style>
